import { IBusStop } from "../busStop";
import { IFavoriteLine, IFavoriteLineData } from "./favoriteLine.types";
import { LineTypeCode, LineTypeName } from "@/types";
import {
  IBookInterval,
  IEarlyDriveData,
  ILineFare,
  ILineSet,
} from "../lineInfo";
import { IBus } from "../lineInfo";

export class FavoriteLine implements IFavoriteLine {
  readonly lineId: string;
  readonly turnId: string;
  readonly lineNum: string;
  readonly plateNum: string;
  readonly lineStartTime: string; // 기점 출발 시간
  readonly routeName: string;
  readonly lineTypeCode: LineTypeCode;
  readonly lineTypeName: LineTypeName;
  readonly busStops: Array<IBusStop>;
  readonly getOnBusStop?: IBusStop; // 승차 정류장
  readonly getOffBusStop?: IBusStop; // 하차 정류장
  readonly firstBusStop: IBusStop; // 기점
  readonly lastBusStop: IBusStop; // 종점
  readonly lineFare: ILineFare; // 금액 정보
  readonly bookIntervals?: IBookInterval[];
  readonly earlyDriveInfos?: IEarlyDriveData[]; // 요일별 조기운행 정보
  readonly lineSets: ILineSet[];
  readonly buses?: IBus[]; // 배정된 버스 차량 번호 정보
  readonly gateNoList?: string; // 승강장 위치
  getOnNotice: boolean; // 승차 정류장 알림 설정 여부
  getOffNotice: boolean; // 승차 정류장 알림 설정 여부
  monthlyBookChecked: boolean; // 월예약 여부
  isBoarding: boolean; // 탑승중 여부
  boardUid?: string; // 탑승 식별자
  boardedCarNo?: string; // 탑승중 차량반호
  requestGetOffBusStopId?: string; // 하차를 요청한 정류장 식별자
  /** 탑승 중이라 임시로 즐겨찾기 되었는지 여부 */
  isTempOnboardFavorite?: boolean;
  detourBeginDtm?: string;
  detourEndDtm?: string;
  detourReason?: string;

  constructor(data: IFavoriteLineData) {
    this.lineId = data.lineId;
    this.turnId = data.turnId;
    this.lineNum = data.lineNum;
    this.plateNum = data.plateNum;
    this.lineStartTime = data.lineStartTime;
    this.routeName = data.routeName;
    this.lineTypeCode = data.lineTypeCode;
    this.lineTypeName = data.lineTypeName;
    this.busStops = data.busStops;
    this.getOnBusStop = data.getOnBusStop;
    this.getOffBusStop = data.getOffBusStop;
    this.firstBusStop = data.firstBusStop;
    this.lastBusStop = data.lastBusStop;
    this.lineFare = data.lineFare;
    this.bookIntervals = data.bookIntervals;
    this.earlyDriveInfos = data.earlyDriveInfos;
    this.lineSets = data.lineSets;
    this.buses = data.buses;
    this.gateNoList = data.gateNoList;
    this.getOnNotice = data.getOnNotice;
    this.getOffNotice = data.getOffNotice;
    this.monthlyBookChecked = data.monthlyBookChecked;
    this.isBoarding = data.isBoarding;
    this.boardUid = data.boardUid;
    this.boardedCarNo = data.boardedCarNo;
    this.requestGetOffBusStopId = data.requestGetOffBusStopId;
    this.isTempOnboardFavorite = data.isTempOnboardFavorite;
    this.detourBeginDtm = data.detourBeginDtm;
    this.detourEndDtm = data.detourEndDtm;
    this.detourReason = data.detourReason;
  }
}
